import React from 'react';
import PropTypes from 'prop-types';

import { useProps, useClassName } from 'components/pure/hooks';

import './index.scss';

const propTypes = {}
const imutableProps = {}
const mutableProps = {}

const classNames = {
  default: 'tabs',
}

export default function TabsWrapper({ children, className, ...props }) {
  className = useClassName(classNames, className)

  return <div {...useProps(props, imutableProps)} className={className}>
    {children}
  </div>
}

TabsWrapper.propTypes = propTypes
TabsWrapper.defaultProps = mutableProps

export { default as TabsContent } from './Content'